export default __webpack_public_path__ + "static/Edvita Kelley-Smith-dfed7823690545d750c6a069c80fc491.jpg";